import { create } from '@storybook/theming/create';

export default create({
  base: 'light',
  
  fontCode: 'monospace',

  brandUrl: 'https://estudioflow.com.br',
  brandTitle: 'uxflow',
  brandImage: '/logo.svg',
});
